import React from 'react';
import { makeStyles, withStyles} from 'external/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';


export default function CheckboxList(props) {

  const {
      options, 
      canSelectAll,
      selectAllLabel,
      checked, 
      handleToggle,
      handleSelectAll,
      mapLabel = o => o.label,
      mapValue = o => o.value,
      Secondary,
      Text,
      classes,
      disabled
  } = props

  const allSelected = checked.length == options.length
  const someSelected = !allSelected && checked.length > 0

  return (
    <List className={classes.root} >
      {canSelectAll && options.length > 0 && (
        <ListItem role={undefined} dense button onClick={() => handleSelectAll(allSelected ? [] : options.map(o => mapValue(o)))}>
        <ListItemIcon>
          <Checkbox
            disabled={disabled}
            edge="start"
            checked={allSelected} 
            indeterminate={someSelected}
            tabIndex={-1}
            disableRipple
            inputProps={{ 'aria-labelledby': 'checkbox-list-label-selectAll'}}
          />
        </ListItemIcon>
        <ListItemText id='checkbox-list-label-selectAll' primary={selectAllLabel} />
      </ListItem>)}

      {options.map((option) => {
            const label = mapLabel(option)
            const value = mapValue(option)
            const labelId = `checkbox-list-label-${value}`;

        return (
          <ListItem key={value} role={undefined} dense button onClick={() => !disabled && handleToggle(value, option) }>
            <ListItemIcon>
              <Checkbox
                disabled={disabled}
                edge="start"
                checked={checked.indexOf(value) !== -1}
                tabIndex={-1}
                disableRipple
                inputProps={{ 'aria-labelledby': labelId }}
              />
            </ListItemIcon>
            {!Text && (<ListItemText id={labelId} primary={label} />) }    
            {Text && (<Text option={option} />) }
            {Secondary && (<Secondary option={option} />)}
          </ListItem>
        );
      })}
    </List>
  );
}
